import moment from 'moment';

import {
  DATE_TIME_FORMAT,
  BODY_TEMPERATURE_THRESHOLD,
} from '../../utilities/constants';

/**
 * 更新用パラメータを作成
 * @param {object} param 更新パラメーター
 * @return {object} API通信用更新パラメーター
 * */
const createUpdateCheckInOutSettingsRequestParams = param => {
  const updateParam = Object.create(null);
  updateParam.day_crossing_time = param.day_crossing_time.format(
    DATE_TIME_FORMAT.utcTimeSecondFormat
  );
  updateParam.ccus_auto_send_flg = String(param.ccus_auto_send_flg);
  updateParam.recording_method = String(param.recording_method);
  updateParam.automatic_approval_flg = String(param.automatic_approval_flg);
  updateParam.integration_service_ids = param.integration_service_ids;
  updateParam.body_temperature_threshold = param.body_temperature_threshold;
  updateParam.spot_flg = param.spot_flg;
  updateParam.use_worker_entrance_app_flg = param.use_worker_entrance_app_flg;
  updateParam.use_k_mobile_flg = param.use_k_mobile_flg;
  updateParam.original_field_id = param.original_field_id;
  updateParam.unidentified_logs_auto_send_flg =
    param.unidentified_logs_auto_send_flg;
  if (
    param.defaultReflectResultFlg !== param.use_check_in_reflect_to_result_flg
  ) {
    updateParam.use_check_in_reflect_to_result_flg = String(
      param.use_check_in_reflect_to_result_flg
    );
    if (param.use_check_in_reflect_to_result_flg) {
      updateParam.use_check_in_reflect_to_result_start_date =
        param.use_check_in_reflect_to_result_start_date;
    }
  }
  return updateParam;
};

/**
 * APIのレスポンスのパース
 * @param {*} data レスポンスのデータ
 * @returns {*} パースされたデータ
 */
const parseFetchCheckInOutSettingsResponseData = data => {
  const result = data.entities.check_in_out_setting;
  result.day_crossing_time = moment(
    result.day_crossing_time,
    DATE_TIME_FORMAT.utcTimeSecondFormat
  );
  // APIからのデータはString型なので、型を変換する
  result.ccus_auto_send_flg = Number(result.ccus_auto_send_flg);
  result.automatic_approval_flg = Number(result.automatic_approval_flg);
  result.default_use_check_in_reflect_to_result_flg = Number(result.default_use_check_in_reflect_to_result_flg);
  result.use_check_in_reflect_to_result_flg = Number(result.use_check_in_reflect_to_result_flg);
  result.defaultReflectResultFlg = result.use_check_in_reflect_to_result_flg;
  result.belongs_to_main_jv_flg = Number(result.belongs_to_main_jv_flg);
  result.recording_method = Number(result.recording_method);
  result.spot_flg = Number(result.spot_flg);
  result.use_worker_entrance_app_flg = Number(result.use_worker_entrance_app_flg);
  result.show_location_info_flg = Number(result.show_location_info_flg);
  result.use_k_mobile_flg = Number(result.use_k_mobile_flg);
  result.original_field_id = result.original_field_id;
  result.k_mobile_available_flg = Number(result.k_mobile_available_flg);
  result.original_field_status = result.original_field_status;
  result.unidentified_logs_auto_send_flg = Number(
    result.unidentified_logs_auto_send_flg
  );
  if (!BODY_TEMPERATURE_THRESHOLD.includes(result.body_temperature_threshold)) {
    result.body_temperature_threshold = BODY_TEMPERATURE_THRESHOLD[0];
  }
  return result;
};

/**
 * 現場設定画面で利用するビジネスロジック格納クラス
 * */
const FieldSettingsService = {
  createUpdateCheckInOutSettingsRequestParams,
  parseFetchCheckInOutSettingsResponseData,
};

export default FieldSettingsService;



// WEBPACK FOOTER //
// ./src/services/fieldSettings/FieldSettingsService.js